import { blogPosts } from "../../../mocks/Cleario";
import WaveDivider from "./WaveDivider";

export default function BlogSection() {
  const featured = blogPosts.find((p) => p.featured);
  const others = blogPosts.filter((p) => !p.featured);

  return (
    <div>
      <section className="py-20 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          {/* Header */}
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
            <div>
              <div className="inline-flex items-center gap-2 bg-cl-lime rounded-full px-4 py-1.5 mb-5 thick-border cartoon-shadow-sm">
                <span className="text-cl-dark text-xs font-black uppercase tracking-widest">Cleario Reads</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-black text-cl-dark leading-tight">
                Waste wisdom from<br />the Cleario crew.
              </h2>
            </div>
            <a
              href="/news"
              className="inline-flex items-center gap-2 bg-cl-dark text-white font-black text-sm px-7 py-3.5 rounded-2xl cartoon-btn cursor-pointer whitespace-nowrap"
            >
              View all articles
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
            {/* Featured */}
            {featured && (
              <a href={featured.href} className="lg:col-span-3 group block cursor-pointer">
                <div className="bg-white rounded-3xl overflow-hidden cartoon-card h-full flex flex-col">
                  <div className="relative overflow-hidden" style={{ height: "280px" }}>
                    <img
                      src={featured.image}
                      alt={featured.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <span className="absolute top-4 left-4 bg-cl-lime text-cl-dark text-xs font-black uppercase tracking-widest px-3 py-1.5 rounded-full border-2 border-cl-dark cartoon-shadow-sm">
                      Featured
                    </span>
                  </div>
                  <div className="p-7 flex-1 flex flex-col justify-between">
                    <div>
                      <p className="text-cl-green text-xs font-black uppercase tracking-widest mb-3">{featured.date}</p>
                      <h3 className="text-cl-dark font-black text-2xl leading-snug group-hover:text-cl-green transition-colors mb-3">
                        {featured.title}
                      </h3>
                      <p className="text-cl-dark/60 text-sm leading-relaxed font-semibold">{featured.excerpt}</p>
                    </div>
                    <div className="flex items-center gap-2 mt-5 text-cl-green font-black text-sm">
                      Read article <i className="ri-arrow-right-line"></i>
                    </div>
                  </div>
                </div>
              </a>
            )}

            {/* Small articles */}
            <div className="lg:col-span-2 flex flex-col gap-5">
              {others.map((post) => (
                <a key={post.id} href={post.href} className="group block cursor-pointer flex-1">
                  <div className="bg-white rounded-2xl overflow-hidden cartoon-card h-full flex flex-row">
                    <div className="w-28 flex-shrink-0 overflow-hidden border-r-2 border-cl-dark">
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-full object-cover min-h-full transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                    <div className="p-4 flex flex-col justify-center">
                      <p className="text-cl-green text-xs font-black uppercase tracking-widest mb-1.5">{post.date}</p>
                      <h3 className="text-cl-dark font-black text-sm leading-snug group-hover:text-cl-green transition-colors">
                        {post.title}
                      </h3>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Wave into FAQ (very light bg) */}
      <WaveDivider fromColor="#ffffff" toColor="#f3f9e8" flip />
    </div>
  );
}
